import React, {  Component } from 'react';

export default class OrderStatusDescriptionsOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('OrderStatusDescriptionsOverlayDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="orderStatusDescriptionsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                <a className="closeButton fontSize-10" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Order Status Descriptions</h2>
					<table className="dataTable orderStatusDescriptionsTable">
						<thead>
							<tr>
								<th>Status</th>
								<th>Status Description</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>ENTERED</td>
								<td>Order has been saved and no action will be taken until order is booked</td>
							</tr>
							<tr>
								<td>BOOKED</td>
								<td>Order has been booked and action is being taken to ship the product</td>
							</tr>
							<tr>
								<td>CLOSED</td>
								<td>Order has been delivered and billed</td>
							</tr>
						</tbody>
					</table>
				</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/orderStatusDescriptionsOverlayDialog.js